import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';

interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

// POST /api/v1/me/change-password — server verifies the current password
// via BCrypt before hashing+storing the new one. Returns 204 on success
// and 401 Auth.CurrentPasswordIncorrect when current is wrong (the form
// surfaces that as a field-level error rather than a generic toast).
//
// We deliberately don't invalidate any other cache here: password change
// doesn't alter the cached profile shape, doesn't rotate tokens (per
// backend handler comment), and doesn't change the JWT. The form just
// resets its values on success.
export function useChangePassword() {
  return useMutation<void, Error, ChangePasswordInput>({
    mutationFn: async (input) => {
      await apiClient.post('api/v1/me/change-password', { json: input });
    },
  });
}
